// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "autocomplete__option-AUqX1";
export { _1 as "__esModule", _2 as "autocomplete__option" }
export default { "__esModule": _1, "autocomplete__option": _2 }
